import { processedActivities } from "@/types/my-activities";
import { IDX_DB_VALUE_KEYS, indexedDbStorage } from "@/utils/indexDBStorage";
import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

// Define the interfaces
interface OrderedItem {
  id?: string;
  __typename?: string;
  createdAt?: string;
  type?: string;
}

interface ActivityData {
  orderedItems?: OrderedItem[];
  activities?: any[];
  circleRecommendations?: any[];
  eventRecommendations?: any[];
  connectionRecommendations?: any[];
  skillRecommendations?: any[];
  endorsements?: any[];
  circleInvitations?: any[];
  eventInvitations?: any[];
  championRequests?: any[];
  championInvitations?: any[];
  mentorshipRequests?: any[];
  connectionActivities?: any[];
  skillVerificationRequests?: any[];
  relationshipUpgradeRequests?: any[];
  [key: string]: any; // Index signature for dynamic access
}

interface MyActivitiesState {
  activities: ActivityData | null;
  setActivities: (activities: ActivityData) => void;
  updateActivities: (
    updater: (activities: ActivityData | null) => ActivityData
  ) => void;
  clearActivities: () => void;
  processedActivities?: processedActivities[];
}

// Create the store
const useMyActivityStore = create<MyActivitiesState>()(
  persist(
    (set) => ({
      activities: null,
      setActivities: (activities: ActivityData) => set({ activities }),
      updateActivities: (updater) =>
        set((state) => ({
          activities: updater(state.activities),
        })),
      clearActivities: () => set({ activities: null }),
    }),
    {
      name: IDX_DB_VALUE_KEYS.myActivity,
      storage: indexedDbStorage as unknown as PersistStorage<unknown>,
      partialize: (state) => ({
        processedActivities: state?.processedActivities,
      }),
    }
  )
);

export default useMyActivityStore;
